function maxFileSizeByList(fileTable, MaxSizeBybytes) {
  return fileTable[0].value.some((e) => e.size > MaxSizeBybytes);
}

export default maxFileSizeByList;
